'use strict';

class InvoiceDraftInternational {
  constructor($scope, $filter, $routeParams, $location, invoiceService, recipientService, originatorService, commonService, userService, Notification) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$location = $location;
    this.invoiceService = invoiceService;
    this.recipientService = recipientService;
    this.originatorService = originatorService;
    this.commonService = commonService;
    this.userService = userService;
    this.Notification = Notification;
    this.invoiceNumber = $routeParams.number;
  }

  $onInit() {
    this.lastInvoice = null;
    this.alert = {};
    this.accountNumbers = [];
    this.loadedDueDateFromRecipient = false;
    this.summaryCalculated = false;
    this.originatorLoaded = false;
    this.invoiceLoaded = false;
    this.currenciesLoaded = false;
    this.defaults = null;
    this.displayContractNumber = false;
    this.displayProjectReference = false;

    this.invoice = {
      invoiceDate: moment().format('YYYY-MM-DD'),
      dueDate: moment().format('YYYY-MM-DD'),
      orderDate: moment().format('YYYY-MM-DD'),
      accountNumber: null,
      deliveryDate: null,
      deliveryAddress: {
        address: null,
        zip: null,
        city: null,
        country: 'NORGE'
      },
      currency: 'NOK',
      ourReference: null,
      yourReference: null,
      contractReference: null,
      orderNumber: null,
      invoiceText: null,
      recipient: {},
      items: []
    };

    this.taxRates = [];

    // get taxRates
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
        // let ar = Array.apply(null, new Array(this.taxRates.length)).map(Number.prototype.valueOf, 0);
        let l = this.taxRates.length;
        // let net = Array(l).fill(0);
        // let tax = Array(l - 1).fill(0);
        let net = Array.apply(null, new Array(l)).map(Number.prototype.valueOf, 0);
        let tax = Array.apply(null, new Array(l - 1)).map(Number.prototype.valueOf, 0);

        if (!this.summaryCalculated) {
          this.summary = {
            net: net,
            tax: tax,
            total: 0,
            taxRates: this.taxRates
          };
        }
      });

    this.i18n = {
      QUANTITY: 'Quantity',
      CODE: 'Product',
      DESCRIPTION: 'Description',
      UNITPRICE: 'Price',
      DISCOUNT: 'Disc. %',
      TAXRATE: 'VAT',
      TOTAL: 'Sum'
    };

    this.taxEnabled = false;
    this.discount = 0;
    this.summary = {
      net: [],
      tax: [],
      total: 0,
      taxRates: []
    };

    this.currencies = [{
      code: 'NOK',
      name: 'Norske kroner',
      rate: 1
    }];
    this.currency = this.currencies[0];

    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });

    this.commonService.getExchangeRates()
      .then((resp) => {
        this.currencies = resp;
        this.currenciesLoaded = true;
        this.updateCurrency();
      });

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;

        this.accountNumbers = [];
        this.accountNumbers.push(
          {
            number: this.originator.bankAccount.number,
            bic: this.originator.bankAccount.bic,
            iban: this.originator.bankAccount.iban
          }
        );

        if (this.originator.bankAccount.additionalBankAccounts && this.originator.bankAccount.additionalBankAccounts.length > 0) {
          this.originator.bankAccount.additionalBankAccounts.forEach((a) => {
            this.accountNumbers.push(a);
          });
        }

        this.updateAccountNumberOnInvoice();
        this.originatorForDisplay = angular.copy(this.originator);
        this.updateAccountOnOriginatorForDisplay();

        if (this.invoice.international) {
          this.invoice.international.bic = resp.data.bankAccount.bic;
          this.invoice.international.iban = resp.data.bankAccount.iban;
        } else {
          this.invoice.international = {
            bic: resp.data.bankAccount.bic,
            iban: resp.data.bankAccount.iban,
            vatNumber: null
          };
        }
      });

    if (this.invoiceNumber === 'ny' && this.$location.search().template) {
      this.invoiceService.getDraftFromTemplate(this.$location.search().template)
        .then((resp) => {
          this.loadData(resp);
          this.currency.code = resp.data.currency;
          this.updateCurrencyOnInvoice();
        });
    }

    if (this.invoiceNumber === 'ny' && this.$location.search().timetrack) {
      this.invoiceService.getDraftFromTimeTrack(this.$location.search().timetrack)
        .then((resp) => this.loadData(resp));
    }

    this.$scope.$watch('$ctrl.invoice.accountNumber', (val, old) => {
      if (val && val !== old) {
        //update accountno on originator
        this.updateAccountOnOriginatorForDisplay();

        this.accountNumbers.forEach((item) => {
          if (val === item.number) {
            if (this.invoice.international) {
              this.invoice.international.bic = item.bic;
              this.invoice.international.iban = item.iban;
            } else {
              this.invoice.international = {
                bic: item.bic,
                iban: item.iban,
                vatNumber: null
              };
            }
            //do not display on page load
            if (old !== null) {
              this.Notification.success('BIC/IBAN er oppdatert');
            }
          }
        });
      }
    });

    this.$scope.$watch('$ctrl.currency.code', (val) => {
      this.updateCurrencyOnInvoice(val);
    });

    this.$scope.$on('productList', (e, val) => {
      if (val) {
        this.invoice.items = val;
      }
    });

    this.$scope.$on('productSummary', (e, val) => {
      if (val) {
        this.summaryCalculated = true;
        this.summary = val;
      }
    });

    this.$scope.$watch('$ctrl.invoice.deliveryAddress.zip', (val) => {
      if (val && this.invoice.deliveryAddress.country === 'NORGE') {
        if (val.length === 4) {
          this.commonService.getCityByPostCode(val)
            .then((resp) => {
              this.invoice.deliveryAddress.city = resp.data.city ? resp.data.city : 'OLSO';
            });
        }
      }
    });

    this.$scope.$on('selectedRecipient', (e, val) => {
      if (val) {
        // update yourRef if empty
        if (this.invoice.yourReference === '' || this.invoice.yourReference === null) {
          this.invoice.yourReference = val.yourReference;
        }

        if (this.invoice.international.vatNumber === 'undefined' || this.invoice.international.vatNumber === '' || this.invoice.international.vatNumber === null) {
          this.invoice.international.vatNumber = val.vatNumber;
        }

        // update discount if not set
        if (val.discount > 0 && this.invoice.items.length) {
          this.discount = val.discount;

          this.alert = {
            type: 'info',
            message: `Rabatten på fakturalinjene er endret til <b>${val.discount}%</b>, standardrabatten for <b>${val.name}</b>.`
          };

          this.invoice.items.forEach((item) => {
            item.discount = val.discount;
            return item;
          });
        }

        //don't update currency if opening from template
        if (val.currency && val.currency !== this.currency.code && !this.$location.search().template) {
          // this.updateCurrencyOnInvoice(val.currency);
          this.currency.code = val.currency;
          this.alert = {
            type: 'info',
            message: `Valuta er oppdatert til <b>${val.currency}</b>, standardvalutaen for <b>${val.name}</b>.`
          };
        }

        // update due date
        if (val.creditDays !== null) {
          this.loadedDueDateFromRecipient = true;
          this.invoice.dueDate = moment(this.invoice.invoiceDate, 'YYYY-MM-DD').add(val.creditDays, 'days').format('YYYY-MM-DD');
        }


        // let currentRecipientNumberOnInvoice = this.invoice.recipient !== null ? this.invoice.recipient.number : null;

        this.invoice.recipient = {
          number: val.number,
          customerNumber: val.customerNumber,
          name: val.name,
          email: val.email || null,
          address: {
            address1: val.address.address1 || null,
            address2: val.address.address2 || null,
            zip: val.address.zip || null,
            city: val.address.city || null,
            country: val.address.country || 'NORGE'
          },
          organisationNumber: val.organisationNumber || null,
          icd: val.icd || null,
          labels: val.labels || null
        };
        if (this.invoiceNumber && this.invoiceNumber === 'ny') {
          this.fetchLastInvoiceForRecipient(val.number);
        }
      } else {
        this.invoice.recipient = null;
        this.lastInvoice = null;
      }
    });

    this.commonService.datePicker({
      field: $('#dueDate')[0]
    });

    this.commonService.datePicker({
      field: $('#orderDate')[0]
    });

    this.commonService.datePicker({
      field: $('#deliveryDate')[0]
    });

    if (this.invoiceNumber && this.invoiceNumber !== 'ny') {
      this.load();
    } else {
      this.invoiceLoaded = true;
      this.loadSettings();
    }

    // preload recipient
    if (this.$location.search().kunde) {
      this.invoice.recipient = {
        number: this.$location.search().kunde
      };
    }
  }


  updateCurrency() {
    //don'\'t update currency for template
    if (this.originatorLoaded && this.invoiceLoaded && this.currenciesLoaded && !this.$location.search().template) {
      let currency = this.defaults.currency;
      if (this.invoiceNumber && this.invoiceNumber !== 'ny') {
        currency = this.invoice.currency;
      }
      this.currency.code = currency;
    }
  }

  updateCurrencyOnInvoice(val) {
    if (val === 'NOK') {
      this.invoice.currency = val;
      if (this.invoice.international) {
        this.invoice.international.exchangeRate = 1;
      } else {
        this.invoice.international = {
          exchangeRate: 1,
          vatNumber: null
        };
      }
    } else {
      this.currencies.forEach((currency) => {
        if (val === currency.code) {
          // update invoice
          this.invoice.currency = currency.code;

          if (this.invoice.international) {
            this.invoice.international.exchangeRate = currency.rate;
          } else {
            this.invoice.international = {
              exchangeRate: currency.rate,
              vatNumber: null
            };
          }
          return true;
        }
      }, this);
    }
  }

  updateAccountNumberOnInvoice() {
    if (this.originator && !this.$filter('isEmptyObject')(this.originator)) {
      let found = this.accountNumbers.some(an => an.number === this.invoice.accountNumber);
      if (this.invoice.accountNumber === null || !found) {
        this.invoice.accountNumber = this.originator.bankAccount.number;
      }
    }
  }

  updateAccountOnOriginatorForDisplay() {
    if (this.invoice && this.originatorForDisplay) {
      this.originatorForDisplay.bankAccount.number = this.invoice.accountNumber;
    }
  }

  fetchLastInvoiceForRecipient(recipientNo) {
    if (recipientNo && recipientNo !== 'undefined') {
      this.invoiceService.fetchLastInvoiceForRecipient(recipientNo)
        .then((resp) => {
          this.lastInvoice = resp.data;
        });
    }
  }

  loadSettings() {
    this.originatorService.settings()
      .then((resp) => {
        this.defaults = resp.data.defaults;
        if (this.invoiceNumber && this.invoiceNumber === 'ny' && !this.$location.search().timetrack) {
          this.invoice.invoiceText = resp.data.defaults.invoice.textInternational;
        }

        if (this.invoice.invoiceDate) {
          if (!this.loadedDueDateFromRecipient) {
            this.invoice.dueDate = moment(this.invoice.invoiceDate, 'YYYY-MM-DD').add(resp.data.defaults.invoice.dueDays, 'days').format('YYYY-MM-DD');
          }
        }

        this.taxEnabled = resp.data.defaults.totalIncludeMva;
        this.displayContractNumber = resp.data.defaults.displayContractNumber;
        this.displayProjectReference = resp.data.defaults.displayProjectReference;

        if (this.invoice.ourReference === null) {
          this.invoice.ourReference = resp.data.defaults.invoice.ourRef;
        }
        this.originatorLoaded = true;
        this.updateCurrency();
      });
  }

  loadData(resp) {
    this.invoice = resp.data;
    this.invoice.invoiceDate = moment().format('YYYY-MM-DD');

    if (this.$location.hash() === 'kopi') {
      this.invoice.orderDate = moment().format('YYYY-MM-DD');
      this.invoice.deliveryDate = null;
    }
    this.invoiceLoaded = true;
    this.updateAccountNumberOnInvoice();
    // check currency
    this.loadSettings();
  }

  selectLastInvoice() {
    let dueDate = this.invoice.dueDate;
    let invoiceDate = this.invoice.invoiceDate;
    let orderDate = this.invoice.orderDate;
    let deliveryDate = this.invoice.deliveryDate;

    this.invoice = this.lastInvoice;
    this.invoice.dueDate = dueDate;
    this.invoice.orderDate = orderDate;
    this.invoice.invoiceDate = invoiceDate;
    this.invoice.deliveryDate = deliveryDate;

    this.lastInvoice = null;
    this.currency.code = this.invoice.currency;
  }

  load() {
    if (this.$location.hash() === 'kopi') {
      this.invoiceService.get(this.invoiceNumber)
        .then((resp) => this.loadData(resp));
    } else {
      this.invoiceService.getDraft(this.invoiceNumber)
        .then((resp) => this.loadData(resp));
    }
  }

  calc(items) {
    let total = 0;

    items.forEach((i) => {
      total += i;
    });

    return total;
  }

  recipientError(err) {
    if (err.data && err.data.errors && err.data.errors.length) {
      err.data.errors.forEach((error) => {
        if (error.name.indexOf('recipient.') !== -1) {
          if ($('#recipientSearch').length) {
            $('#recipientSearch')
              .removeClass('ng-valid')
              .removeClass('ng-empty')
              .addClass('ng-invalid')
              .addClass('ng-dirty');
          } else {
            $('#recipientSearch')
              .removeClass('ng-invalid')
              .removeClass('ng-dirty')
              .addClass('ng-valid')
              .addClass('ng-empty');
          }
        }
      });
    }
  }

  process(draft = false) {
    let a = 1;
    if (a === 1) {
      // return;
    }
    $('div.error.system').remove();
    this.alert = {};
    // don't make any call if the total is 0
    if (this.summary.total === '0.00') {
      this.alert = {
        type: 'error',
        message: 'Totalsummen må være større enn 0,00'
      };

      return;
    }

    // cleanup items
    if (this.invoice.items.length) {
      this.invoice.items.forEach((item) => {
        item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
        item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
        return item;
      }, this);
    }

    if (draft) {
      if (this.$filter('isEmptyObject')(this.invoice.recipient)) {
        delete this.invoice.recipient;
      }
    } else {
      if (!this.invoice.recipient || this.$filter('isEmptyObject')(this.invoice.recipient) || !this.invoice.recipient.name) {
        this.alert = {
          type: 'error',
          message: 'Mottager er påkrevd'
        };

        this.sendButtonDisabled = false;

        return;
      }
    }

    //No longer do that because additional accountno might be selected
    // // Update originator
    // if (this.invoice.international && this.invoice.international.bic && this.invoice.international.iban) {
    //   this.originator.bankAccount.iban = this.invoice.international.iban;
    //   this.originator.bankAccount.bic = this.invoice.international.bic;
    //
    //   this.originatorService.update(this.originator);
    // }

    if (this.invoiceNumber && this.invoiceNumber !== 'ny' && this.$location.hash() !== 'kopi') {
      this.invoiceService.updateDraft(this.invoiceNumber, this.invoice)
        .then(() => {
          if (draft) {
            this.$location.path(`/oversikt`);
          } else {
            this.$location.path(`/regning/kladd/${this.invoiceNumber}/send`);
          }
        })
        .catch((err) => this.recipientError(err));
    } else {
      this.invoiceService.saveDraft(this.invoice)
        .then((resp) => {
          if (draft) {
            this.$location.path(`/oversikt`);
          } else {
            this.$location.path(`/regning/kladd/${resp.data.number}/send`);
          }
        })
        .catch((err) => this.recipientError(err));
    }
  }

  save() {
    this.process(true);
  }

  send() {
    this.process();
  }

  delete() {
    if (this.invoiceNumber) {
      this.invoiceService.deleteDraft(this.invoiceNumber)
        .then(() => this.$location.path('/oversikt'));
    }
  }

  cancel() {
    this.$location.path('/beslutning-kreves');
  }

  changeLanguage() {
    swal({
      title: 'Bytt til norsk faktura?',
      text: 'Du vil miste det du har skrevet på denne regningen.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0c4d91',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Avbryt',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
        if (this.originator.giroLayout) {
          this.$scope.$apply(() => this.$location.path('/regning/kladd/ny'));
        } else {
          this.$scope.$apply(() => this.$location.path('/regning/kladd/utengiro/ny'));
        }
      }
    });
  }
}

InvoiceDraftInternational.$inject = ['$scope', '$filter', '$routeParams', '$location', 'invoiceService', 'recipientService', 'originatorService', 'commonService', 'userService', 'Notification'];

const invoiceDraftInternational = {
  controller: InvoiceDraftInternational,
  templateUrl: 'invoice/draft-international.html'
};

angular
  .module('SendRegning')
  .component('invoiceDraftInternational', invoiceDraftInternational)
  .config(($routeProvider) => {
    $routeProvider
      .when('/regning/kladd/engelsk/:number', {
        title: 'Ny regning',
        template: '<invoice-draft-international />',
        noSidebar: true,
        overlay: true,
        secure: true
      });
  });

